import React, { useEffect } from "react";
import { useSnackbar, DURATION } from "baseui/snackbar";
import { ReactComponent as GreenTickSvg } from "../../../../../../assets/img/green-tick.svg";
import { ReactComponent as CloseIconSvg } from "../../../../../../assets/img/close-white.svg";

const useEmailSentSuccess = (emailSentSuccess, emailSentFail) => {
    const { enqueue } = useSnackbar();

    useEffect(() => {
        if (emailSentSuccess) {
          enqueue(
            {
              message:
                "A login link has been sent to your email. Please use it to access Turing on desktop.",
              startEnhancer: () => <GreenTickSvg />,
              focus: false,
              actionMessage: <CloseIconSvg />
            },
            DURATION.medium
          );
        }
      }, [emailSentSuccess]);

    useEffect(() => {
      if (emailSentFail) {
        enqueue(
          {
            message:
              "Error Sending Email, Please try again",
            focus: false,
            actionMessage: <CloseIconSvg />
          },
          DURATION.short
        );
      }
    }, [emailSentFail])
}

export default useEmailSentSuccess;